import axios from 'axios';

const api_axios = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_BASE_URL+''+process.env.REACT_APP_BASE_URL,
});

const base_axios = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_BASE_URL,
});

// export default setAuthToken;
export { api_axios, base_axios };